
import React from "react";
import Breadcrumb from '../components/breadcrumb'
import Alert from '../components/ServerRequestAlert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faApple, faWindows } from '@fortawesome/free-brands-svg-icons'
import imperativeFetch from '../services/imperativeFetch';

export default (props) => {

  const query=props.location.search;
  var fakeurl = new URL("http:a/"+query);
  const downloadURL=fakeurl.searchParams.get('url');
  const productName=fakeurl.searchParams.get('name');
  const i=downloadURL.lastIndexOf('/');
  const downloadFile=downloadURL.substring(i+1);
  const signupRequested=fakeurl.searchParams.has('signup');
  const signupSuccess=fakeurl.searchParams.get('signup')=="true";

  imperativeFetch('/api/v1/licensing/downloadNotify?product='+productName,{method:'get'});

  fetch(downloadURL, {
    method: 'GET',
  })
  .then((response) => response.blob())
  .then((blob) => {
    // Create blob link to download
    const url = window.URL.createObjectURL(
      new Blob([blob]),
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      downloadFile,
    );

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);
  });

  return (
    <div>
      <Breadcrumb path={ [ {name: "Download " + productName}]} />
      <div className="container top-margin">
        <div className="row">
          <div className="col-sm-12">
            <div class="alert alert-primary">
              <p>Your download of <b>{productName} </b>should start now. If not, please click for following
              link <a href={downloadURL}>{downloadFile}</a>.</p>
              { signupRequested && signupSuccess && ( 
                  <p>You should also shortly receive a confirmation email with your account details. Please
                    confirm and set a password. This can then be used to register your trial within the plugin.
                  </p>
              )}
              { signupRequested && !signupSuccess && ( 
                  <p>Sorry couldn't create an account with that email address - maybe you already have an account?
                    If so please use that to register your trial, otherwise please manually create an account.
                  </p>
              )}

            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};